import { $fetch, $post } from '@/services/axios';

export function fetch() {
  return $fetch(`system/debug`);
}

export function debug(domain, model) {
  return $post(`system/debug/${domain}`, model);
}
